import { useEffect, useState } from 'react';
/**
 * Hook that reports whether the user has `prefers-reduced-motion: reduce`.
 * WCAG 2.3.3 — animated content must respect reduced-motion preferences.
 */
export function usePrefersReducedMotion() {
    const [reduced, setReduced] = useState(false);
    useEffect(() => {
        if (typeof window === 'undefined' || !window.matchMedia) {
            return;
        }
        const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
        const handler = () => setReduced(mq.matches);
        handler();
        mq.addEventListener?.('change', handler);
        return () => mq.removeEventListener?.('change', handler);
    }, []);
    return reduced;
}
//# sourceMappingURL=usePrefersReducedMotion.js.map